import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { customMiddleware } from './custom-middleware';
import { createReduxHistoryContext } from 'redux-first-history';
import createSagaMiddleware from 'redux-saga';
import createAppReducer from '../reducers/appReducer';
import rootSaga from '../sagas/root-saga';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
    reduxTravelling: true, // Enable for route state syncing
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
    createAppReducer({
        router: routerReducer
    }),
    composeWithDevTools(
        applyMiddleware(
            routerMiddleware,
            thunk,
            sagaMiddleware,
            customMiddleware
        )
    )
);

sagaMiddleware.run(rootSaga);

export const history = createReduxHistory(store);
export default store;
